import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { UiObject } from "@models/configurators/ui-object";
import { ITab, IHtml } from "@models/entity-models";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IDummyNode } from "./kb-object";
import { eRuleType } from "@models/enums";
import { RuleContainer } from "./rule-container";

@Kbo(CToken.Html)
export class Html extends UiObject implements IHtml {

    constructor(kom: KbObjectManager) {
        super(kom, { ruleType: eRuleType.html });
        this.$rulesNode = { id: this.id + "_rules", $type: "RulesNode", allowedChildren: () => [CToken.Rule], getParent: () => this }
    }
    
    public value: string;

    public $rulesNode: IDummyNode;

    public ruleContainers: RuleContainer[] = [];
}
